import { render, staticRenderFns } from "./ab-save.vue?vue&type=template&id=fd34e3f0&scoped=true&"
import script from "./ab-save.vue?vue&type=script&lang=js&"
export * from "./ab-save.vue?vue&type=script&lang=js&"
import style0 from "./ab-save.vue?vue&type=style&index=0&id=fd34e3f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd34e3f0",
  null
  
)

export default component.exports